import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import BarraTitulo from "../../Generico/BarraTitulo";
import CopyToClipboard from "react-copy-to-clipboard";
import LinkIcon from "@mui/icons-material/Link";
import BorderClearIcon from "@mui/icons-material/BorderClear";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const LinkMenu = ({ identificadores, baixarQRCode, onCopy }) => {
  const navigate = useNavigate();

  if (!identificadores.length) return null;

  return (
    <Box>
      <BarraTitulo
        title="Link do cardápio"
        subTitle="Compartilhe e divulgue o link em suas redes sociais. Facebook, WhatsApp, Site, Instagram entre outros"
      />
      <Paper>
        <Box p={3}>
          {identificadores.map((identificador) => (
            <Grid container key={identificador.id}>
              <Grid
                size={{
                  xs: 12,
                  md: 8
                }}>
                <Box p={1}>
                  <Typography color="primary" variant="h6">
                    <a
                      href={"http://" + identificador.uuid + ".qrpedir.com"}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {identificador.uuid}.qrpedir.com
                    </a>
                  </Typography>
                </Box>
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  md: 4
                }}>
                <Box display="flex" justifyContent="flex-end">
                  <Box p={1}>
                    <CopyToClipboard
                      text={identificador.uuid + ".qrpedir.com"}
                      onCopy={onCopy}
                    >
                      <Button startIcon={<LinkIcon />} color="primary">
                        Copiar
                      </Button>
                    </CopyToClipboard>
                  </Box>

                  <Box p={1}>
                    <Button
                      onClick={() => baixarQRCode(identificador.uuid)}
                      startIcon={<BorderClearIcon />}
                    >
                      QRCode
                    </Button>
                  </Box>

                  <Box p={1}>
                    <Button
                      onClick={() => navigate("/Delivery")}
                      startIcon={<EditIcon />}
                    >
                      Editar
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default LinkMenu;
